import { ItemDataService } from "data/service/item-data-service";
import { CommentService } from "data/service/comment-service";
import { GanttInfoService } from 'data/service/gantt-info-service';

import {
	AttachmentInfo,
	Comment,
	ItemStatus,
	Item,
	ChildItemInfo,
	ItemType,
	ListItem,
	Tag,
	ItemTag,
	AppointmentInfo,
	GanttInfo,
	LookupListItem,
	TimeTraker
} from "data/entities/entities";
import { autoinject, singleton, LogManager } from 'aurelia-framework';
//import { MessageBox } from "core/message-box";
import { EntityStatuses, ItemTypes, ItemStatuses, EntityStatusCodes } from "core/enums";
import { DialogService } from 'aurelia-dialog';
import { Prompt } from 'shared/components/prompt/prompt';
import { Alert } from 'shared/components/alert/alert';
import { bindable, computedFrom } from "aurelia-framework";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { ListItemDataService } from 'data/service/list-item-data-service';
import { AddTaskDialog } from 'pages/entity/components/add-task-dialog';
import { AppEvents } from 'core/app-events';
import { AuthService } from 'aurelia-authentication';
import { AppointmentInfoService } from 'data/service/appointment-info-service';
import { StatInfoService } from 'data/service/stat-info-service';
import { ChildItemInfoService } from 'data/service/child-item-info-service';
import * as $ from "jquery";
import { MetadataService } from 'data/service/meta-data-service';
import { CloseTaskDialog } from './components/dialog/closeTask/close-task-dialog';
import { ReopenTaskDialog } from './components/dialog/reopenTask/reopen-task-dialog';
import { ItemTagService } from 'data/service/item-tag-service';
import { ValidationController } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation/bootstrap-form-renderer';
import { TimeTrakerService } from '../../data/service/time-traker-service';

@autoinject()
@singleton()
export class EntityController {
	fileTooBigNotification(event) {
		const options = { message: "Sorry, that file is too big to upload.", title: "File Upload Error" };
		this.dialogService.open({ viewModel: Alert, model: options });
	}

	confirmDeleteFile(item) {
		const options = { message: "Are you sure you want to delete this file?", content: item.fileName, title: "Confirm" };

		this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.deleteFile(item);
			}
		});
	}

	async updateAttachment(item) {
		await this.dataService.updateFile(item);
		// item.save();
		//await this.item.attachmentInfos[0].description._add(item);
	}

	async deleteFile(item) {
		await this.dataService.deleteFile(item.attachmentId);
		await this.item.attachmentInfos._remove(item);
	}

	moveItemTo(droppedOnId: number, droppedId: number): any {
		this.dataService.moveItemTo(droppedOnId, droppedId);
	}

	allowRowDragAndDrop = true;
	eventSubscriptions: Array<Subscription> = [];
	currentDate: Date = new Date();//Used by the calendar.
	scheduleSettings; //This is set when getting appointmentdata,otherwise, appointments do not show up in the Scheduler.
	appointmentInfos: Array<AppointmentInfo> = [];
	appointmentInfosOriginal: Array<AppointmentInfo> = [];
	isEditingDetails = false;
	timeTrakerDetails: Array<TimeTraker> = [];
	toggleClockInOut = false;
	note: string;
	logger = LogManager.getLogger('EntityController');

	constructor(
		private dialogService: DialogService,
		private timeTrakerService: TimeTrakerService,
		private commentService: CommentService,
		private eventAggregator: EventAggregator,
		private listItemDataService: ListItemDataService,
		private dataService: ItemDataService,
		private authService: AuthService,
		private itemTagService: ItemTagService,
		private appointmentInfoService: AppointmentInfoService,
		private ganttInfoService: GanttInfoService,
		private statInfoService: StatInfoService,
		private childItemInfoService: ChildItemInfoService,
		public metadataService: MetadataService,
		bootstrapFormRenderer: BootstrapFormRenderer,
		private validationController: ValidationController
	) {
		this.initializeCommentEntity();
		this.subscribeToEvents();//This must be done here, as there is no attached or activate for injected classes (ie, not a component or screen).
		this.validationController.addRenderer(bootstrapFormRenderer);
	}

	closeMultipleItems() {
		//if (this.item.itemTypeId != ItemTypes.Task) return;
		this.item.closeDate = new Date();
		this.dialogService.open({ viewModel: CloseTaskDialog, model: this }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.itemChildren.forEach((child) => {
					if (child.isChecked) {
						child.itemStatusId = this.item.itemStatusId;
						child.parentId = this.item.parentId;
						child.note = this.item.note;
						child.closeDate = this.item.closeDate;
						//this.item = child;
						this.saveMultipleItem(child);
					}
				});
				//Call Refresh Grid Event.
				this.getChildrenOfItem(EntityStatusCodes.Active);
			}
			else {
				this.cancelEdit(this.item);
			}
		});
	}

	showClosedItems() {
		this.originalChildItem = this.itemChildren;
		this.itemChildren = this.itemChildren.filter(x => x.itemStatusId === 9);
	}

	showAllItems() {
		this.itemChildren = this.originalChildItem;
	}

	hideClosedItems() {
		this.originalChildItem = this.itemChildren;
		this.itemChildren = this.itemChildren.filter(x => x.itemStatusId !== 9);
	}

	onSchedulerActionComplete(event) {
		const requestType = event.requestType;
		if (requestType === "appointmentEdit") {
			const data = event.data[0];
			this.appointmentChanged(data);
		}

		if (requestType === "appointmentSave") {
			const data = event.data[0];
			this.saveNewAppointment(data);
		}

		this.logger.info("onSchedulerActionComplete()");
	}

	async saveNewAppointment(data: Item) {
		const result = await this.validationController.validate();
		if (result.valid) {
			// validation succeeded
			const newAppointment = this.dataService.getNew();
			if (data.name) {
				newAppointment.name = data.name;
			}

			if (data.startDate) {
				newAppointment.startDate = data.startDate;
			}

			if (data.dueDate) {
				newAppointment.dueDate = data.dueDate;
			}

			if (data.description) {
				newAppointment.description = data.description;
			}
			this.addNewTask(newAppointment);
		} else {
			console.log("failure");
			// validation failed
		}
	}

	appointmentChanged(appointment) {
		this.logger.info("appointmentChanged");
		const id = appointment.id;
		const original = this.appointmentInfosOriginal.find(a => a.id === id);
		const revised = appointment;
		for (let property in revised) {
			//Update the original
			original[property] = revised[property];
		}
		original.save();
	}

	appointmentResizeStop(args) {
		this.logger.info("resizeStop");
		const id = args.detail.appointment.id;
		const original = this.appointmentInfosOriginal.find(a => a.id === id);
		const revised = args.detail.appointment;
		for (let property in revised) {
			//Update the original
			original[property] = revised[property];
		}
		original.save();
	}

	async validate() {
		const result = await this.validationController.validate();
		if (result.valid) {
			return true;
		} else {
			return false;
		}
	}

	reopenTask() {
		//This is here because this is called when the Icon is clicked, even if it happens to be a Folder instead of a task.
		if (this.item.itemTypeId !== ItemTypes.Task) return;
		this.dialogService.open({ viewModel: ReopenTaskDialog, model: this }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.saveChanges();
			}
		});
	}

	closeTask() {
		//This is here because this is called when the Icon is clicked, even if it happens to be a Folder instead of a task.
		if (this.item.itemTypeId !== ItemTypes.Task) return;
		this.item.closeDate = new Date();
		this.dialogService.open({ viewModel: CloseTaskDialog, model: this }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.saveChanges();
			}
			else {
				this.cancelEdit(this.item);
			}
		});
	}

	moveUp(item: ChildItemInfo) {
		this.logger.info("Move Up");
		this.dataService.moveUp(item);
	}

	moveDown(item: ChildItemInfo) {
		this.logger.info("Move Down");
		this.dataService.moveDown(item);
	}

	showClosedTasks() {
		this.getDecendants(this.entityId, "CLOSED");
	}

	getDecendants(parentId: number, code: string) {
		this.dataService.getDecendants(parentId, code);
	}

	itemStatusInfos: [] = [];
	dueStatusInfos: [] = [];

	async getItemStatusSummary(parentId: number) {
		this.logger.info("getItemStatusSummary()");
		this.itemStatusInfos = await this.statInfoService.getItemStatusInfoByFolderId(parentId, 'ALL');
		this.refreshItemStatusSummaryChart();
	}

	async getDueStatusSummary(parentId: number) {
		this.logger.info("getDueStatusSummary()");
		const parameters = {
			currentDate: new Date().toISOString().slice(0, 10),
			ownershipStatusCode: 'ALL',
			parentId: parentId
		};
		this.dueStatusInfos = await this.statInfoService.getDueStatusInfo(parameters);
		this.refreshDueStatusSummaryChart();
	}

	refreshDueStatusSummaryChart() {
		this.logger.info('RefreshingDueStatusSummaryChart()');
		const chart = $("#dueStatusSummaryChart").data("ejChart");
		if (chart) {
			chart.model.series[0].dataSource = this.dueStatusInfos;
			chart.animate(null);
		}
		//I dislike using setTimeout, but I have found no other way to get the chart to display.
		else {
			this.logger.info('Chart is null');
			window.setTimeout(() => {
				this.refreshDueStatusSummaryChart();
			}, 0);
		}
	}

	refreshItemStatusSummaryChart() {
		this.logger.info('RefreshingItemStatusSummaryChart()');
		const chart = $("#itemStatusSummaryChart").data("ejChart");
		if (chart) {
			chart.model.series[0].dataSource = this.itemStatusInfos;
			chart.animate(null);
		}
		else {
			this.logger.info('Chart is null');
			window.setTimeout(() => {
				this.refreshItemStatusSummaryChart();
			}, 0);
		}
	}

	onGanttActionComplete(event) {
		const requestType = event.requestType;
		if (requestType === "recordUpdate") {
			const item = event.item;
			//Clean children, because we don't want to save them at the same time as the parent.
			this.ganttInfoService.saveItem(item);
		}
		this.logger.info("onActionComplete()");
	}

	ganttToolbarSettings = {
		showToolbar: true,
		toolbarItems: ["add", "edit", "delete", "update", "cancel", "expandAll", "collapseAll", "search", "prevTimeSpan", "nextTimeSpan", "criticalPath", "excelExport"]
	};

	ganttEditSettings = {
		allowEditing: true,
		allowAdding: true,
		allowDeleting: true,
		allowIndent: true,
		editMode: 'cellEditing'
	};

	rootGanttItem: Array<GanttInfo> = [];
	rootGanttItemOriginal: any;
	ganttControl: any;

	ganttToolbarClick(args) {
		const id = $(args.currentTarget).attr("id");
		if (id === "gantt_excelExport") {
			const url = 'api/export/excel/' + this.entityId + '?token=12345';
			(window as any).location = url;
			args.cancel = true;
		}
	}

	async getGanttData() {
		try {
			this.logger.info("Getting Gantt Info");
			if (this.entityId) {
				let result = await this.ganttInfoService.find(this.entityId);
				if (result) {
					if (!Array.isArray(result)) result = [result]
					this.rootGanttItem = result;
				}
			}
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	private unsubscribeFromEvents() {
		for (let entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	private subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.EXPLORER_REFRESHED, payload => this.onExplorerRefreshed()))
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.CURRENT_ITEM_CHANGED, payload => {
			this.onCurrentItemChanged(payload);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.ITEM_NAME_CHANGED, payload => {
			this.onItemNameChanged(payload);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.AUTHENTICATION_CHANGE, authenticated => {
			this.onAuthenticated(authenticated);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
	}

	onExplorerRefreshed() {
		if (this.selectRootAfterExplorerRefresh) {
			this.selectRootAfterExplorerRefresh = false;
			this.eventAggregator.publish(AppEvents.SELECT_ROOT);
		}
	}

	//There is no detached or destructor in Javascript, so this will never run.
	detached() {
		this.logger.info("detached");
		this.unsubscribeFromEvents();
	}

	dragItemStart(event, item) {
		this.eventAggregator.publish(AppEvents.DRAG_ITEM_START, item);
		this.logger.info("dragItemStart()");
		try {
			if (item) {
				event.target.style.opacity = '0.4';
				event.dataTransfer.setData("text/plain", item.id);
				return true;
			}
		} catch (ex) {
			console.log("dragStart Exception was caught:" + ex.message);
		}
	}

	dragItemEnd(event, item) {
		this.eventAggregator.publish(AppEvents.DRAG_ITEM_END, item);
		this.logger.info("dragItemEnd()");
		try {
			event.target.style.opacity = '1';
		} catch (ex) {
			console.log("dragStart Exception was caught:" + ex.message);
		}
	}

	async getScheduleData() {
		try {
			this.logger.info("Getting Appointments");
			this.appointmentInfosOriginal = await this.appointmentInfoService.find(this.item.id);
			this.appointmentInfos = this.appointmentInfosOriginal.map(x => Object.assign({}, x));//Save a copy of the originals so it can be saved later.
			this.scheduleSettings = {
				applyTimeOffset: false,
				dataSource: this.appointmentInfos,
				id: 'id',
				subject: 'name',
				startTime: 'startDate',
				endTime: 'dueDate',
				description: 'description',
				allDay: 'allDay',
				recurrence: 'recurrence',
				recurrenceRule: 'recurrenceRule'
			};
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	async onFolderTabActivate(args) {
		this.logger.info("onFolderTabActivate()");
		if (args.detail.activeIndex === 0) {
			this.refreshItemStatusSummaryChart();
		}
		if (args.detail.activeIndex === 1) {
			this.logger.info("creatingCalendar");
			//This is a workaround for the calendar displaying incorrect inside of a tab control on init. https://www.syncfusion.com/support/directtrac/incidents/210333
			$("#taskCalendar").css('display', 'block');
			const cal = $("#taskCalendar").data("ejSchedule");
			cal.refreshScroller();
		}
		if (args.detail.activeIndex === 2) {
			const obj = $("#gantt").data("ejGantt");
			const tabViewPortHeight = $('#tab-view-port').height();
			const tabHeaderHeight = $('#folder-view-tab-header').height();
			//This is a hack to correctly size the Gantt Chart to take up the available height. Failed to do this with css/flex.
			const ganttChartHeight = ((tabViewPortHeight - tabHeaderHeight) * .95) + 'px';//Calcuate the height and subtract 5%.
			this.logger.info('gantt height:' + ganttChartHeight);
			if (obj) {
				obj.setModel({ "sizeSettings": { "height": ganttChartHeight, "width": "100%" } });
				obj.setSplitterPosition('50%');
			}
		}
	}

	filteredTags: Array<Tag> = [];
	//Remove all tags from the list which are already in use.
	filterTagSelectionList() {
		this.logger.info("filterTagSelection()");
		this.filteredTags = null;
		const list = this.metadataService.tags.slice();//Create a shallow copy.

		if (this.item.itemTags) {
			this.item.itemTags.forEach((a: ItemTag) => list._removeObjectById(a.tagId));
			this.filteredTags = list;
			this.logger.info("filteredTagcount:" + this.filteredTags.length + "tagCount:" + this.metadataService.tags.length);
		}
	}

	async addItemTag(eventDetail) {
		let tag: Tag | string = eventDetail.item;
		if (typeof tag === "string") {
			const cleaned = tag.replace("(Add New)", "");
			tag = await this.metadataService.addTagAsync(cleaned);
		}
		const newItemTag = this.itemTagService.AddNewItemTag(tag, this.item.id);
		this.item.itemTags._add(newItemTag)
		this.filterTagSelectionList();
	}

	//A convience method.
	saveChanges() {
		this.saveItem(this.item);
	}

	async saveItem(item: Item) {
		const isValid = await this.validate();
		if (isValid) {
			this.addRelatedItems(item);
			if (item.itemTypeId !== item.itemType.id) {
				this.updateItemType(item);
			}
			item.isEditing = false;
			item.save();
			this.eventAggregator.publish(AppEvents.ITEM_NAME_CHANGED, item);
			this.eventAggregator.publish(AppEvents.EDIT_MODE_CHANGED, "VIEW_MODE");
			this.metadataService.getMetadata();
		}
	}

	async saveMultipleItem(item: Item) {
		const isValid = await this.validate();
		if (isValid) {
			this.addRelatedItems(item);
			if (item.itemTypeId !== item.itemType.id) {
				this.updateItemType(item);
			}
			item.isEditing = false;
			item.save();
			this.eventAggregator.publish(AppEvents.ITEM_MOVED, item);
			this.eventAggregator.publish(AppEvents.ITEM_NAME_CHANGED, item);
			this.eventAggregator.publish(AppEvents.EDIT_MODE_CHANGED, "VIEW_MODE");
			this.metadataService.getMetadata();
		}
	}

	cancelPropertyEdit() {
		this.dataService.rejectChanges(this.item);
	}

	async savePropertyEdit() {
		//The properties are validated by the PropertyWidget, so no need to repeat here.
		this.addRelatedItems(this.item);
		try {
			await this.item.save();
			this.eventAggregator.publish(AppEvents.STATUS_MESSAGE, "Saved Property");
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	addComment() {
		this.logger.info("controller.addComment()");
		this.newComment.content = " ";//Work around for HTML Editor throwing an error because newComment.content is null.
		this.newComment.isEditing = true;
	}

	onCurrentItemChanged(payload) {

	}

	cleanDetails(content: string): string {
		if (content === "<p><span></span></p>") {
			content = null;
		}
		return content;
	}

	addItemByTypeId(id: number) {
		this.eventAggregator.publish(AppEvents.ADD_NEW_ITEM, id);
	}

	async refreshCurrentItem() {
		if (this.entityId) {
			try {
				this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
				this.getChildrenOfItem(EntityStatusCodes.Active);
				const item: Item = await this.getDetails(this.entityId);
				this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);
				if (item) {
					this.item = item;
					if (item.itemTypeId === ItemTypes.Folder || item.itemTypeId === ItemTypes.Root) {
						this.getItemStatusSummary(this.entityId);
						this.getDueStatusSummary(this.entityId);
					}
					this.filterTagSelectionList();
					this.getScheduleData();
				}
				else
					this.item = null;
			}
			catch (error) {
				this.logger.error(error);
			}
		}
	}

	clearData(): any {
		this.item = null;
		this.entityId = null;
		this.cancelNew();
	}

	onAuthenticated(authenticated: boolean): void {
		if (!authenticated) {
			this.clearData();
		}
	}

	heading: string;
	items: Array<Item> = [];
	searchText: string;
	isAdding = false;
	newItem: Item;
	item: Item;
	itemHistory: Item;
	itemChildren: Array<Item>;
	originalChildItem: Array<Item>;
	showDetails = false;
	showGrandChildren = false;

	@computedFrom('item.progress')
	get progressPercentage(): string {
		if (this.item && this.item.progress) {
			return this.item.progress + "%";
		}
		else return "";
	}

	currentComment = "";
	currentModifiedComment = "";
	newComment: Comment;
	isEditing = false;
	isEditingDescription = false;
	isEditingBudget = false;
	isEditingDueDate = false;
	isEditingStartDate = false;
	entityId: number;
	topLevelItems: Array<Item>;
	canEdit = true;
	showProperties = false;
	showFiles = false;
	showComments = false;
	showPageHeader = true;
	showEntityHeader = false;
	timeTraker: TimeTraker;
	@bindable selectedFiles: FileList;

	archiveItem(item: Item) {
		this.dataService.moveItemAndChildren(item, EntityStatuses.Archived);
		this.eventAggregator.publish(AppEvents.ITEM_MOVED, item);
	}

	ActivateItem(item: Item) {
		this.dataService.moveItemAndChildren(item, EntityStatuses.Active);
		this.eventAggregator.publish(AppEvents.ITEM_MOVED, item);
	}

	confirmUnDeleteItem(item: Item) {
		this.confirmArchiveItem(item);
	}

	confirmUnarchiveItem(item: Item) {
		let message;
		if (this.itemChildren && this.itemChildren.length > 0) {
			message = `Are you sure you want to restore this item and all of it's children? (${this.itemChildren.length} items)`;
		} else {
			message = "Are you sure you want to restore this item?";
		}
		const options = { message: message, content: item.name, title: "Confirm", okButtonText: "Yes", cancelButtonText: "No" };
		this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.ActivateItem(item);
			}
		});
	}

	confirmArchiveItem(item: Item) {
		if (!item.parentId) {
			this.preventRootArchiveOrDeletion(item);
			return;
		}
		let message;
		if (this.itemChildren && this.itemChildren.length > 0) {
			message = `Are you sure you want to archive this item and all of it's children? (${this.itemChildren.length} items)`;
		} else {
			message = "Are you sure you want to archive this item?";
		}
		const options = { message: message, content: item.name, title: "Confirm", okButtonText: "Yes", cancelButtonText: "No" };
		this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.archiveItem(item);
			}
		});
	}

	preventRootArchiveOrDeletion(item: Item) {
		const message = "The root item cannot be archived or deleted";
		const options = {
			message: message,
		};

		this.dialogService.open({ viewModel: Alert, model: options });
	}

	confirmDeleteItem(item: Item) {
		if (!item.parentId) {
			this.preventRootDeletion(item);
			return;
		}
		let message;
		if (this.itemChildren && this.itemChildren.length > 0) {
			message = `Are you sure you want to delete this item and all of it's children? (${this.itemChildren.length} items)`;
		} else {
			message = "Are you sure you want to delete this item?";
		}
		const options = { message: message, content: item.name, title: "Confirm", okButtonText: "Yes", cancelButtonText: "No" };
		this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.deleteItem(item);
			}
		});
	}

	addTokenHeaderForUpload(event) {
		event.xhr.setRequestHeader("Authorization", "Bearer " + this.authService.getIdToken());
	}

	addNewTaskDialog() {
		this.dialogService.open({ viewModel: AddTaskDialog, model: this }).whenClosed(response => {
			if (!response.wasCancelled) { }
		});
	}

	async addNewTask(child: Item) {
		try {
			child.parentId = this.item.id;
			child.entityStatusId = EntityStatuses.Active;
			child.itemStatusId = ItemStatuses.New;
			child.itemTypeId = ItemTypes.Task;
			const item = await child.save();
			item.parent = this.item;
			this.addRelatedItems(item);
			this.eventAggregator.publish(AppEvents.NEW_ITEM_ADDED, item);
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	addRelatedItems(item: Item) {
		if (!item.entityStatus || item.entityStatusId !== item.entityStatus.id) {
			this.updateEntityStatus(item);
		}
		if (!item.itemStatus || item.itemStatusId !== item.itemStatus.id) {
			this.updateStatusType(item);
		}
		if (!item.timeScaleType || item.timeScaleTypeId !== item.timeScaleType.id) {
			this.updateTimeScaleType(item);
		}
		if (!item.importanceType || item.importanceTypeId !== item.importanceType.id) {
			this.updateImportanceType(item);
		}
		if (!item.processStep || item.processStepId !== item.processStep.id) {
			this.updateProcessStep(item);
		}
		if (!item.priorityType || item.priorityTypeId !== item.priorityType.id) {
			this.updatePriorityType(item);
		}
		if (!item.itemType || item.itemTypeId !== item.itemType.id) {
			this.updateItemType(item);
		}
		if (!item.assignedTo || item.assignedToId !== item.assignedTo.id) {
			this.updateAssignedTo(item);
		}
	}

	updateAssignedTo(item: Item) {
		const newId = parseInt(item.assignedToId as any);
		const newItem = this.metadataService.appUsers.find((i) => i.id === newId);
		if (newItem) item.assignedToName = newItem.fullName;
	}

	updateItemType(item: Item) {
		const newTypeId = parseInt(item.itemTypeId as any);
		const newItemType = this.metadataService.itemTypes.find((i) => i.id === newTypeId);
		if (newItemType) item.itemType = newItemType;
	}

	updatePriorityType(item: Item) {
		const newId = parseInt(item.priorityTypeId as any);
		const newType = this.metadataService.priorityTypes.find((i) => i.id === newId);
		if (newType) item.priorityType = newType;
	}

	updateProcessStep(item: Item) {
		const newId = parseInt(item.processStepId as any);
		const newType = this.metadataService.processSteps.find((i) => i.id === newId);
		if (newType) item.processStep = newType;
	}

	updateImportanceType(item: Item) {
		const newId = parseInt(item.importanceTypeId as any);
		const newType = this.metadataService.importanceTypes.find((i) => i.id === newId);
		if (newType) item.importanceType = newType;
	}

	updateStatusType(item: Item) {
		const newId = parseInt(item.itemStatusId as any);
		const newType = this.metadataService.itemStatuses.find((i) => i.id === newId);
		if (newType) item.itemStatus = newType;
	}

	updateTimeScaleType(item: Item) {
		const newId = parseInt(item.timeScaleTypeId as any);
		const newType = this.metadataService.timeScaleTypes.find((i) => i.id === newId);
		if (newType) item.timeScaleType = newType;
	}

	updateEntityStatus(item: Item) {
		const newId = parseInt(item.entityStatusId as any);
		const newType = this.metadataService.entityStatuses.find((i) => i.id === newId);
		if (newType) item.entityStatus = newType;
	}

	async deleteItem(item: Item) {
		try {
			await this.dataService.deleteItemAndChildren(item);
			this.eventAggregator.publish(AppEvents.STATUS_MESSAGE, `"${item.name}" was Deleted`);
			this.eventAggregator.publish(AppEvents.ITEM_DELETED, item);
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	async getMetadata() {
		await this.metadataService.getMetadata();
	}

	removeListItemFromParent(listItem: ListItem) {
		this.item.listItems._remove(listItem);
	}

	addListItem() {
		this.listItemDataService.addListItem(this.item);
	}

	editItem(item: Item) {
		item.isEditing = true;
		this.eventAggregator.publish(AppEvents.EDIT_MODE_CHANGED, "EDIT_MODE");
	}

	multipleOpen = true;
	save = 'api/attachments/uploadnew';

	onUpload(event) {
		event.data = this.item.id;
	}

	onUploadSuccess(event) {
		console.log(event);
		const response = event.responseText;
		const attachmentInfo = JSON.parse(response);
		this.item.attachmentInfos._add(attachmentInfo);
	}

	onDirectoryChanged(payload) {
		this.clearData();
	}

	onItemNameChanged(changedItem: Item) {
		if (this.item && this.item.id === changedItem.id) {
			this.item.name = changedItem.name;
		}
	}

	//Main: The primary entry point, called by entity.ts.
	async activate(params, routeConfig) {
		this.timeTrakerDetails = [];
		this.toggleClockInOut = false;
		this.logger.info("activate called with parameter of " + params)
		await this.getItemData(params);
		await this.getItemHistory(params);
		await this.getTimeTrakerDetails(params.id);
	}

	selectRootAfterExplorerRefresh = false;

	private async getItemHistory(params: any) {
		this.entityId = params.id;
		this.logger.info('Activate Fired with param of:' + this.entityId);
		if (this.entityId) {
			try {
				const itemHistory: Item = await this.getHistoryDetails(this.entityId);
				if (itemHistory) {
					this.itemHistory = itemHistory;
				}
				else
					this.itemHistory = null;
			}
			catch (error) {
				this.logger.error(error);
			}
		}
	}

	private async getItemData(param: any) {
		const newId = param.id;
		if (!newId) {
			this.logger.debug("setting selectRootAfterExplorerRefresh to true");
			this.selectRootAfterExplorerRefresh = true;
			return;
		}
		if (this.entityId === newId) return;
		if (newId === 0) return;
		this.entityId = param.id;
		this.logger.info('Activate Fired with param of:' + this.entityId);
		const isEditing = param.isEditing;
		const oldItem = this.item;
		if (this.entityId) {
			try {
				this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
				//Stats needs to be reviewed.
				//this.getProjectStats(OwnershipType.All);//Put first for speed reasons.
				this.getChildrenOfItem(EntityStatusCodes.Active);
				const item: Item = await this.getDetails(this.entityId);
				this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);
				if (item) {
					this.item = item;
					if (item.itemTypeId === ItemTypes.Folder || item.itemTypeId === ItemTypes.Root) {
						this.getItemStatusSummary(this.entityId);
						this.getDueStatusSummary(this.entityId);
					}
					if (isEditing) {
						item.isEditing = true;
					}
					//No longer being used?
					this.filterTagSelectionList();
					this.getScheduleData();
					//this.getGanttData();Causing a Freeze in the UI. Remove for now. 2018-10-23
					this.publishCurrentItemChanged(item, oldItem);
				}
				else
					this.item = null;
			}
			catch (error) {
				this.logger.error(error);
			}
		}
	}

	publishCurrentItemChanged(item: Item, oldItem: Item) {
		this.eventAggregator.publish(AppEvents.CURRENT_ITEM_CHANGED, { newValue: item, oldValue: oldItem });
	}

	clearNew() {
		this.newItem = null;
	}

	cancelNew() {
		this.clearNew();
		this.isAdding = false;
	}

	archiveAttachmentInfo(item: AttachmentInfo) {
		item.entityStatusId = EntityStatuses.Archived;
		item.save();
		this.item.attachmentInfos._remove(item);
	}

	moveAttachmentInfoToTrashcan(item: AttachmentInfo) {
		item.entityStatusId = EntityStatuses.Trashed;
		item.save();
		this.item.attachmentInfos._remove(item);
	}

	showExtraData = true;

	editComment(item: Comment) {
		item.isEditing = true;
	}

	cancelCommentEdit(item: Comment) {
		item.isEditing = false;
	}

	selectRoot() {
		this.eventAggregator.publish(AppEvents.SELECT_ROOT);
	}

	preventRootDeletion(item: Item) {
		const message = "The root item cannot be deleted";
		const options = {
			message: message
		};
		this.dialogService.open({ viewModel: Alert, model: options });
	}

	confirmDeleteComment(item: Comment) {
		const options = { message: "Are you sure you want to delete comment?", title: "Confirm" };
		this.dialogService.open({ viewModel: Prompt, model: options }).whenClosed(response => {
			if (!response.wasCancelled) {
				this.deleteComment(item);
			}
		});
	}

	deleteComment(item: Comment) {
		item.entityStatusId = EntityStatuses.Trashed;
		this.item.comments._remove(item);
		item.save();
	}

	saveCommentEdit(item: Comment) {
		item.isEditing = false;
		item.save();
	}

	cancelNewComment() {
		this.initializeCommentEntity();
	}

	async saveNewComment() {
		this.newComment.isEditing = false;
		if (this.newComment.content.trim() === '') return;
		this.newComment.createdDate = new Date();
		this.newComment.entityStatusId = EntityStatuses.Active;
		this.newComment.itemId = this.item.id;
		this.item.comments._add(this.newComment);
		try {
			await this.newComment.save();
			this.eventAggregator.publish(AppEvents.CURRENT_ITEM_CHANGED, "Comment Saved")
			this.logger.info("new comment saved");
			this.initializeCommentEntity();
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	initializeCommentEntity() {
		this.newComment = this.commentService.getNew();
		this.newComment.isEditing = false;
		this.logger.info("new comment initialized");
	}

	//setUpImportanceTypes() {
	//    this.dialogService.open({ viewModel: EditImportanceTypes })
	//        .whenClosed((result: DialogCloseResult) => {
	//            if (!result.wasCancelled) {
	//                let items: Array<ImportanceType> = result.output;
	//                let currentItem = items.find(a => a.id === this.item.importanceType.id);

	//                if (currentItem) {
	//                    this.item.importanceType = items.find(a => a.id === currentItem.id);
	//                }
	//            }
	//        });
	//}

	//setUpPriorityTypes() {
	//    this.dialogService.open({ viewModel: EditPriorityTypes })
	//        .whenClosed((result: DialogCloseResult) => {
	//            if (!result.wasCancelled) {
	//                let items: Array<PriorityType> = result.output;
	//                let currentItem = items.find(a => a.id === this.item.priorityTypeId);

	//                if (currentItem) {
	//                    this.item.priorityType = items.find(a => a.id === currentItem.id);
	//                }
	//            }
	//        });
	//}

	// setUpStatusTypes() {

	//     this.dialogService.open({ viewModel: EditStatusTypes })
	//.whenClosed(
	//(result: DialogCloseResult) => {
	//             if (!result.wasCancelled) {
	//                 //Update the current status in case it changed
	//                 let items: Array<ItemStatus> = result.output;
	//                 let currentItem = items.find(a => a.id === this.item.itemStatus.id);

	//                 if (currentItem) {
	//                     this.item.itemStatus = items.find(a => a.id === currentItem.id);
	//                 }
	//             } else {
	//                 //cancelled
	//             }
	//         });
	// }

	//editStatusColor(themeColor: ThemeColor) {
	//    themeColor.save();
	//    this.item.itemStatus.themeColor = themeColor;
	//}

	editImportance(item: LookupListItem) {
		this.item.importanceTypeId = item.id;
		this.item.importanceType = item;
		this.item.save();
	}

	editPriority(item: LookupListItem) {
		this.item.priorityTypeId = item.id;
		this.item.priorityType = item;
		this.item.save();
	}

	editEntityType(itemType: ItemType) {
		this.item.itemTypeId = itemType.id;
		this.item.itemType = itemType;
		this.item.save();
	}

	editStatus(item: ItemStatus) {
		this.item.itemStatusId = item.id;
		this.item.itemStatus = item;
		this.item.save();
	}

	editStartDate() {
		this.isEditingStartDate = true;
	}

	editBudget() {
		this.isEditingBudget = true;
	}

	editDueDate() {
		this.isEditingDueDate = true;
	}

	saveDueDateEdit() {
		this.isEditingDueDate = false;
		this.item.save();
	}

	saveStartDateEdit() {
		this.isEditingStartDate = false;
		this.item.save();
	}

	saveBudgetEdit() {
		this.isEditingBudget = false;
		this.item.save();
	}

	cancelBudgetEdit() {
		this.isEditingBudget = false;
		this.rejectChanges();
	}

	rejectChanges() {
		this.dataService.rejectChanges(this.item);
	}

	cancelStartDateEdit() {
		this.isEditingStartDate = false;
		this.rejectChanges();
	}

	cancelDueDateEdit() {
		this.isEditingDueDate = false;
		this.rejectChanges();
	}

	saveDescriptionEdit() {
		this.isEditingDescription = false;
		this.item.save();
	}

	editDescription() {
		this.isEditingDescription = true;

	}

	cancelDescriptionEdit() {
		this.isEditingDescription = false;
		this.rejectChanges();
	}

	htmlEditor: any;

	cancelEdit(item: Item) {
		this.eventAggregator.publish(AppEvents.EDIT_MODE_CHANGED, "VIEW_MODE");
		item.isEditing = false;
		this.dataService.rejectChanges(item);
	}

	refresh() {
		console.log("refresh not implemented");
	}

	async getChildrenOfItem(entityStatusCode: string) {
		const parameters = {
			currentDate: new Date().toISOString().slice(0, 10),
			parentId: this.entityId,
			entityStatusCode: entityStatusCode
		};
		const items = await this.childItemInfoService.getChildren(parameters);
		this.itemChildren = items;
		this.publishChildrenChangedEvent(items);
	}

	publishChildrenChangedEvent(items) {
		this.eventAggregator.publish(AppEvents.CHILDREN_CHANGED, items);
	}

	getChildrenOfItems(items: Array<Item>, entityStatusTypeId: number) {
		items.forEach(async (a) =>
			a.children = await this.dataService.getChildren(a.id, entityStatusTypeId));
	}

	getDetails(id: number) {
		return this.dataService.getDetails(id);
	}

	async getHistoryDetails(id: number) {
		return await this.dataService.getHistoryDetails(id);
	}

	async getTimeTrakerDetails(taskId: number) {
		this.timeTrakerDetails = await this.timeTrakerService.find(taskId);
		const timeTraker = await this.timeTrakerService.findOne(this.item.id);
		if (isNaN(timeTraker.endTime)) {
			this.toggleClockInOut = false;
		} else {
			this.toggleClockInOut = true;
		}
	}

	new() {

		this.isAdding = true;
		this.newItem = this.dataService.getNew();
		if (this.item) {
			this.newItem.parentId = this.item.id;
		}
	}

	doUnArchive(item: Item) {
		item.entityStatusId = EntityStatuses.Active;
		item.save();
		this.items._remove(item);
	}

	//unArchive(item: Item) {
	//    MessageBox.Confirm("Change status to Active?",
	//        item.title,
	//        () => this.doUnArchive(item)
	//    );
	//}

	//doUnDelete(item: Item) {
	//    item.entityStatusId = EntityStatuses.Active;
	//    item.save();
	//    this.items._remove(item);
	//}

	//unDelete(item: Item) {
	//    MessageBox.Confirm("Change status to Active?",
	//        item.title,
	//        () => this.doUnDelete(item)
	//    );
	//}

	async listActive() {
		this.items = await this.dataService.listActive();
	}

	async listArchived() {
		this.items = await this.dataService.listArchived();
	}

	async listTrashed() {
		this.items = await this.dataService.listTrashed();
	}


	moveToTrashcan(item: Item) {
		item.entityStatusId = EntityStatuses.Trashed;
		item.save();
		this.items._remove(item);
	}

	doDelete(item: Item) {
		item.entityStatusId = EntityStatuses.Trashed;
		item.save();
		this.items._remove(item);
	}

	async clockInClicked() {
		this.timeTraker = this.timeTrakerService.getNew();
		this.timeTraker.note = this.note;
		this.timeTraker.startTime = new Date();
		this.timeTraker.taskId = this.item.id;
		const data = await this.timeTraker.save();
		if (data) {
			await this.getTimeTrakerDetails(this.item.id);
			this.toggleClockInOut = true;
		}
		this.note = "";
	}

	async clockOutClicked() {
		const timeTraker = await this.timeTrakerService.findOne(this.item.id);
		timeTraker.note = this.note;
		timeTraker.endTime = new Date();
		timeTraker.taskId = this.item.id;
		const data = await timeTraker.save();
		if (data) {
			await this.getTimeTrakerDetails(this.item.id);
			this.toggleClockInOut = false;
		}
		this.note = "";
	}
}

